/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { Button } from 'antd-mobile';
import styles from './caseUpload.module.scss';
import { ApiCore } from '../../api/index';
import caseBanner from '../../static/images_medicalLive/case_banner.png';
import promptImg from '../../static/images_medicalLive/prompt.png';
import caseUploadImg from '../../static/images_medicalLive/case_upload.png';

const api = new ApiCore();

function CaseUpload(props: any) {

    // 小程序url
    const [urlScheme, setUrlScheme] = useState<any>('');

    useEffect(() => {
        document.title = '案例上传';
        getUrlScheme()
    }, [])

    /**
     * 生成小程序url scheme
     */
    const getUrlScheme = () => {
        let params = {
            appCode: 'APP001',
            envVersion: '',
            path: 'pages/index/index',
            query: ''
        }
        api.getAppSecretScheme(params).then((res: any) => {
            if (res.code == 0) {
                if (!res.data) {
                    return
                }
                setUrlScheme(res.data)
            }
        });
    }

    /**
     * 案例上传
     */
    const upLoadCase = () => {
        window.location.href = urlScheme
    }

    return (
        <div className={`${styles.caseUpload_content}`}>
            <img src={caseBanner} alt='' className={`${styles.caseBanner}`} />
            <img src={promptImg} alt='' className={`${styles.promptImg}`} />
            <div className={`${styles.caseContent}`}>
                <div>如您希望分享案例，请点击上传</div>
                <Button type="primary" onClick={upLoadCase}>点击案例上传</Button>
                {/* <div>苹果手机请登录电脑端</div>
                <a href='#' className={`${styles.link}`}>{'http://go-case.kydev.net/dist/index.html#/'}</a>
                <div>进行案例上传</div> */}
                <img src={caseUploadImg} alt='' className={`${styles.caseUploadImg}`} />
            </div>
        </div>
    )

}

export default CaseUpload;